const COLORS = {
	install (Vue, options) {
		Vue.prototype.$colors = {

			stringToHsl (str, lum) {
				let sat = 100
				let hash = 0
				for (let i = 0; i < str.length; i++) {
					hash = str.charCodeAt(i) + ((hash << 5) - hash)
				}
				let h = hash % 360
				return 'hsl(' + h + ', ' + sat + '%, ' + lum + '%)'
			},

			stringToRgb (str) {
				var hash = 0
				if (str.length === 0) return hash
				for (var i = 0; i < str.length; i++) {
					hash = str.charCodeAt(i) + ((hash << 5) - hash)
					hash = hash & hash
				}
				var rgb = [0, 0, 0]
				for (i = 0; i < 3; i++) {
					var value = (hash >> (i * 8)) & 255
					rgb[i] = value
				}
				return `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`
			},

			getProjectColor (project, luma) {
				if (!project) return
				const projetColors = {
					behive: {
						light: 'info accent-2',
						dark: 'info darken-1',
						light_text: 'info--text text--accent-2',
						dark_text: 'info--text text--darken-1'
					},
					maestro: {
						light: 'green accent-3',
						dark: 'green darken-1',
						light_text: 'green--text text--accent-3',
						dark_text: 'green--text text--darken-1'
					},
					t1000: {
						light: 'orange accent-2',
						dark: 'orange accent-3',
						light_text: 'orange--text text--accent-2',
						dark_text: 'orange--text text--accent-3'
					},
					gravity: {
						light: 'pink accent-2',
						dark: 'pink accent-3',
						light_text: 'pink--text text--accent-2',
						dark_text: 'pink--text text--accent-3'
					},
					acme: {
						light: 'purple accent-2',
						dark: 'purple',
						light_text: 'purple--text text--accent-2',
						dark_text: 'purple--text'
					}
				}
				project = project.toLowerCase()
				if (projetColors.hasOwnProperty(project)) {
					return projetColors[project][luma || 'light']
				}
				return 'background lighten-1'
			},

			setColor (item) {
				if (item.status === Vue.prototype.$getConst('PROCESSING')) {
					return ['info', 'color--text']
				}
				if (item.status === Vue.prototype.$getConst('DONE')) {
					return ['success', 'color--text']
				}
				if (item.status === Vue.prototype.$getConst('WAITING')) {
					return ['amber', 'color--text']
				}
				if (item.status === Vue.prototype.$getConst('CANCELED')) {
					return ['warning', 'color--text']
				}
				if (item.status === Vue.prototype.$getConst('VALIDATING')) {
					return ['pink', 'color--text']
				}
				if (item.status === Vue.prototype.$getConst('ERROR')) {
					return ['error', 'color--text']
				}
				if (item.status === Vue.prototype.$getConst('STOPPED')) {
					return ['blue-grey', 'color--text']
				}
				return ['white', 'color--text']
			},

			setColorText (item) {
				if (item.status === Vue.prototype.$getConst('PROCESSING')) {
					return 'blue--text'
				}
				if (item.status === Vue.prototype.$getConst('DONE')) {
					return 'success--text'
				}
				if (item.status === Vue.prototype.$getConst('WAITING')) {
					return 'amber--text'
				}
				if (item.status === Vue.prototype.$getConst('CANCELED')) {
					return 'warning--text'
				}
				if (item.status === Vue.prototype.$getConst('ERROR')) {
					return 'error--text'
				}
				if (item.status === Vue.prototype.$getConst('VALIDATING')) {
					return 'pink--text text--lighten-2'
				}
				if (item.status === Vue.prototype.$getConst('STOPPED')) {
					return 'blue-grey--text text--lighten-1'
				}
				return 'white--text'
			},

			setColorTask (item) {
				if (item.status === Vue.prototype.$getConst('DONE')) {
					return ['success', 'white--text']
				}
				if (item.status === Vue.prototype.$getConst('CREATED')) {
					return ['grey', 'white--text']
				}
				if (item.status === Vue.prototype.$getConst('ERROR')) {
					return ['error', 'white--text']
				}
				if (item.status === Vue.prototype.$getConst('STOPPED')) {
					return ['blue-grey', 'white--text']
				}
				if (item.status === Vue.prototype.$getConst('PROCESSING') &&
				(item.trigger === Vue.prototype.$getConst('AUTO') ||
				item.trigger === Vue.prototype.$getConst('REQUEST'))) {
					return ['indigo', 'white--text']
				}
				if (item.trigger === Vue.prototype.$getConst('AUTO') ||
				item.trigger === Vue.prototype.$getConst('REQUEST')) {
					return ['blue', 'white--text']
				}
				if (item.status === Vue.prototype.$getConst('VALIDATING') &&
				item.trigger === Vue.prototype.$getConst('MANUAL')) {
					return ['orange', 'black--text']
				}
				if (item.trigger === Vue.prototype.$getConst('MANUAL')) {
					return ['amber', 'black--text']
				}
			}

		}
	}
}

export default COLORS



// WEBPACK FOOTER //
// ./src/plugins/colors.js